// Pour communiquer entre les onglets
import { Storage, STORAGE_KEYS } from "../../utils/store";

const AUTH_CHANNEL = new BroadcastChannel("auth");
const AUTH_EVENT_TYPE = { LOGIN: "LOGIN", LOGOUT: "LOGOUT", REFRESH: "REFRESH" };

const AUTH_EVENT_CALLBACK = {
    LOGIN: (tokens) => {
        Storage.store(STORAGE_KEYS.JWT, tokens.access, true);
        Storage.store(STORAGE_KEYS.JWT_RENEW, tokens.refresh);
    },

    REFRESH: (tokens) => {
        Storage.store(STORAGE_KEYS.JWT, tokens.access, true);
        Storage.store(STORAGE_KEYS.JWT_RENEW, tokens.refresh);
    },

    LOGOUT: () => {
        
    }
};

const emitAuth = (type, tokens) => AUTH_CHANNEL.postMessage({type, tokens});
const addHandler = (listener) => AUTH_CHANNEL.addEventListener('message', listener);

AUTH_CHANNEL.onmessage = ({ data: msg }) => AUTH_EVENT_CALLBACK[msg.type](tokens);

export {
    AUTH_EVENT_TYPE,
    emitAuth,
    addHandler
};